import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import VacanciesList from '../../components/VacanciesList';
import CitySelect from '../../components/CitySelect';
import WorkersList from '../../components/WorkersList';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadInternshipList } from '../../actions/InternshipListActions';

class PageInternships extends Component {
  static requestData(store) {
    return requestAll([loadInternshipList], store);
  }

  componentDidMount() {
    this.props.actions.loadInternshipList();
  }
  render() {
    return (
      <div>
        <div className="container container--indentVertical-xl">
          <Helmet>
              <title>Стажировки для студентов в ЭР-Телеком Холдинг – Начни карьеру уже сегодня</title>
              <meta name="description" content="Узнай о возможностях стажировок для студентов в ЭР-Телеком Холдинг. Реальные проекты, опытные наставники и шанс начать успешную карьеру в ведущей телекоммуникационной компании." />
          </Helmet>
          <CitySelect main="в Екатеринбурге">Программа “ЭР - Старт” для студентов</CitySelect>
          <div className="text text--top30">Молодежная программа стажировок и практик, которая позволяет студентам попробовать себя в профессии и начать карьеру в федеральном Холдинге.
              <br/>
              40+ ВУЗов
              сотрудничают с «ЭР-Телеком Холдинг» по партнерскому соглашению
              <br/>
              1 150+
              студентов на практике в компании
              <br/>
              100+
              мероприятий для студентов ежегодно
          </div>
            <br/>
            <div className="text text--bottom40 text--bold text--">Переходи на <a href="https://start.rabotaertelecom.ru/">«ЭР-Старт»</a> и лови свой шанс!</div>
        </div>
        <h1 className="text--hide">Стажировка в ЭР-Телеком</h1>
        <div className="container container--indentVertical">
          <VacanciesList cols={6} vacancies={this.props.internshipList} isInternship={this.props.isInternship}/>
        </div>
          <div className="container container--indentVertical">
              <h2 className="text text--h2">Хочешь попасть в одну из крупнейших телеком-компаний России? </h2>

              <div className="text text--bottom40">Присоединяйся к <a href="https://t.me/erstart">телеграм-каналу ЭР-Старт </a> и <a href="https://vk.com/start.rabotaertelecom">группе в VK </a> - тут все о стажировках и карьерном старте!</div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      internshipList: state.internshipList,
      isInternship: true
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadInternshipList }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageInternships));



// WEBPACK FOOTER //
// ./src/pages/PageInternships/index.js